export abstract class ConstantsApp {

  static readonly ENTITY_TYPE_NAMES: string[] = ["Cadena", "Proveedor"];
  static readonly YesOrNo: string[] = ["Si", "No"];

}